import { render } from "./Univ.vue?vue&type=template&id=73370456&scoped=true"
import script from "./Univ.vue?vue&type=script&lang=js"
export * from "./Univ.vue?vue&type=script&lang=js"

import "./Univ.vue?vue&type=style&index=0&id=73370456&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-73370456"

export default script